import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Product, ProductVariants } from '../models/product_list_response';
import { RootState } from '../reducers';
import {
  addToCart as dispatchAddToCart,
  removeFromCart as dispatchRemoveFromCart,
  deleteFromCart as dispatchDeleteFromCart,
  setCoupon as dispatchSetCoupon,
  calculateTotal as dispatchCalculateTotal,
  updateCartQuantity as dispatchUpdateCartQuantity,
  clearCart as dispatchClearCart,
} from '../reducers/cart.reducer';

const useCart = () => {
  const { storeSlug } = useParams<any>();
  const {
    cartItems,
    cartItemCount,
    cartSubTotalAmount,
    coupon: discount,
    cartTotalAmount,
  } = useSelector((state: RootState) => state.cartReducer);
  const dispatch = useDispatch();

  const isItemInCart = (storeProductId: string) =>
    !!cartItems.find((item: Product) => item.storeProductId === storeProductId);

  const isItemVariantInCart = (storeProductId: string, variantId: string) =>
    !!cartItems
      .find((item: Product) => item.storeProductId === storeProductId)
      ?.productVariants.find((v: ProductVariants) => v.id == variantId);

  const getItemInCart = (storeProductId: string) =>
    cartItems.find((item: Product) => item.storeProductId === storeProductId);

  const getItemVariantInCart = (storeProductId: string, variantId: string) =>
    cartItems
      .find((item: Product) => item.storeProductId === storeProductId)
      ?.productVariants.find((v: ProductVariants) => v.id == variantId);

  const addToCart = (product: Product, selectedVariantId?: string) => {
    dispatch(dispatchAddToCart({ product: product, selectedVariantId: selectedVariantId, storeSlug: storeSlug }));
  };

  const removeFromCart = (product: Product, storeProductId: string, selectedVariantId?: string) => {
    dispatch(
      dispatchRemoveFromCart({
        product: product,
        storeProductId: storeProductId,
        selectedVariantId: selectedVariantId,
        storeSlug: storeSlug,
      }),
    );
  };

  const deleteFromCart = (product: Product) => {
    dispatch(dispatchDeleteFromCart({ product: product, storeSlug: storeSlug }));
  };

  const setCoupon = (coupon: string) => {
    dispatch(dispatchSetCoupon(coupon));
  };

  const calculateTotal = () => {
    dispatch(dispatchCalculateTotal({}));
  };

  const updateCartQuantity = (product: Product, updatedQuantity: number, selectedVariantId?: string,) => {
    dispatch(dispatchUpdateCartQuantity({ product: product, storeSlug: storeSlug, updatedQuantity: updatedQuantity,selectedVariantId: selectedVariantId, }));
  };

  const clearCart = () => {
    dispatch(dispatchClearCart({}));
  };

  return {
    cartItems,
    cartItemCount,
    cartSubTotalAmount,
    discount,
    cartTotalAmount,
    isItemInCart,
    isItemVariantInCart,
    getItemInCart,
    getItemVariantInCart,
    addToCart,
    removeFromCart,
    deleteFromCart,
    clearCart,
    updateCartQuantity,
    setCoupon,
    calculateTotal,
  };
};

export default useCart;
